import type { GetTokenResponse } from './responses';
import type { Token } from '../models';
import { ApiSuccessResponse } from '@/shared/types/api.types';

export function mapResponse(apiResponse: GetTokenResponse): ApiSuccessResponse<Token> {
    return new ApiSuccessResponse({
        accessToken: apiResponse.access_token,
        refreshToken: apiResponse.refresh_token,
        expiresIn: apiResponse.expires_in,
        tokenType: apiResponse.token_type,
    });
}
